module.exports = __webpack_public_path__ + "img/8.7683bdf4.jpg";